import type { SxProps, Theme } from "@mui/material";

import { Box, Paper, Typography } from "@mui/material";
import type React from "react";

type CardItemProps = {
  label: string;
  icon?: React.ReactNode;
  styles?: SxProps<Theme>;
  children?: React.ReactNode;
};

export function CardItem({ label, children, icon, styles }: CardItemProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        position: "relative",
        overflow: "hidden",
        bgcolor: "oklch(98% 0.01 294.588)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "3px",
          height: "100%",
          bgcolor: "primary.main",
        },
        ...styles,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
        <Typography sx={{ fontSize: "12px" }}>{icon}</Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 0.3,
            fontSize: "0.7rem",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          fontWeight: 700,
          color: "primary.main",
          display: "flex",
          alignItems: "center",
          width: "100%",
          minHeight: "32px",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}
